module.exports = __webpack_public_path__ + "static/img/pic_rjyf_xmal04.bf4baa04.png";